import './style.scss'

const ActionsButton = ({ action, text, Icon, additionalText = '' }) => {
  return (
    <div
      className='menu__button center'
      onClick={action}>
      <i className={`icon icon--${Icon} s32`}></i>
      <span>{text}</span>
      {additionalText && <div className='menu__button__additional'>{additionalText}</div>}
    </div>
  )
}

export default ActionsButton